module.exports = __webpack_public_path__ + "img/icons-visits.27b7bc6d.svg";